import { Link } from "react-router-dom";

function Header() {
  return (
    <>
      <section className="my-header-bg">
        <div class="container pb-1 pt-2">
          <div className="me-8 w-100 mb-2 d-lg-none d-block">
            <div className="bg-gradient w-100 px-2 py-2 rounded-pill d-flex justify-content-between align-items-center">
              <div className="d-flex justify-content-center align-items-center">
                <i className="bi bi-cup-fill me-3 text-white fs-3 ms-2"></i>
                <p className="m-0 fs-5 text-uppercase lh-normal text-white fw-semibold">
                  Download Tikasa Amruttulya Brochure
                </p>
              </div>
              <a
                href="/assets/brochure.pdf"
                target="_blank"
                class="badge bg-white ms-5 fs-5 py-2 ls-sm rounded-pill px-4 text-dark"
              >
                Download
              </a>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-5 col-12">
              <div className="d-lg-flex d-none">
                <div class="d-flex gap-2 align-items-center lh-0 pe-5">
                  <i className="bi bi-telephone fs-3 text-white"></i>
                  <div className="ms-2 d-flex flex-column lh-1">
                    <span class="fs-5 fw-medium text-white">099211 11101</span>
                    <p class="sm-text-p m-0 fw-light text-white">
                      Call us for Franchise
                    </p>
                  </div>
                </div>
                <div class="d-flex gap-2 align-items-center lh-0 ps-5">
                  <i className="bi bi-whatsapp fs-3 text-success"></i>
                  <div className="ms-2 d-flex flex-column lh-1">
                    <span class="fs-5 fw-medium text-white">099211 11101</span>
                    <p class="sm-text-p m-0 fw-light text-white">Message</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-lg-none d-block">
              <div className="position-relative">
                <img
                  src="/assets/images/logo.png"
                  alt="Tikasa Amruttulya Logo"
                  className="logo-inverse position-absolute border-bottom border-warning rounded-circle"
                  width="90"
                />
              </div>
            </div>

            <div class="col-lg-7 col-12 d-flex align-items-center justify-content-end">
              <div className="me-8 d-lg-block d-none">
                <div className="bg-gradient px-2 py-1 rounded-pill d-flex justify-content-between align-items-center">
                  <div className="d-flex justify-content-center align-items-center">
                    <i className="bi bi-cup-fill me-3 text-white fs-3 ms-2"></i>
                    <p className="m-0 sm-text-p text-uppercase lh-normal text-white fw-semibold">
                      Download Tikasa Amruttulya
                      <br /> Brochure
                    </p>
                  </div>
                  <a
                    href="/assets/brochure.pdf"
                    target="_blank"
                    class="badge bg-white ms-5 py-2 ls-sm rounded-pill px-4 text-dark"
                  >
                    Download Now
                  </a>
                </div>
              </div>

              <div class="d-flex gap-1 align-items-center justify-content-end lh-0">
                <a href="https://www.facebook.com/share/1DE81s3JyS/" target="_blank">
                  <img src="/assets/images/facebook.png" width="33" />
                </a>
                <a href="https://www.instagram.com/tikasaamruttulya" target="_blank">
                  <img src="/assets/images/instagram.png" width="33" />
                </a>
                <img src="/assets/images/twitter.png" width="33" />
                <img src="/assets/images/linkdin.png" width="33" />
                <img src="/assets/images/youtube.png" width="33" />
              </div>
            </div>
          </div>
        </div>

        <nav className="navbar navbar-expand-lg py-2 px-0 z-1 shadow-none border-0">
          <div className="container">
            <div className="ms-auto d-flex align-items-center order-lg-3">
              <div className="d-flex align-items-center">
                <div>
                  <div class="avatar avatar-sm bg-white rounded-circle d-flex justify-content-center border-0 align-items-center me-1 cursor-pointer">
                    <a
                      href="tel:+919921111101"
                      class="d-flex justify-content-center align-items-center"
                    >
                      <i className="bi bi-telephone text-primary fs-4"></i>
                    </a>
                  </div>
                </div>
                <a
                  href="#contact"
                  className="btn bg-white px-5 py-1 fs-4 fw-normal ls-sm rounded-pill text-primary border-0"
                >
                  Become a Franchise Partner
                </a>
              </div>
            </div>

            <div className="collapse navbar-collapse" id="navbar-default">
              <ul className="navbar-nav mt-3 mt-lg-0">
                <li className="nav-item">
                  <a href="#home" className="nav-link ps-0">
                    Home
                  </a>
                </li>
                <li className="nav-item">
                  <a href="#about" className="nav-link">
                    About Us
                  </a>
                </li>
                <li className="nav-item">
                  <a href="#why-tikasa" className="nav-link">
                    Why Tikasa ?
                  </a>
                </li>
                <li className="nav-item">
                  <a href="#products" className="nav-link">
                    Our Products
                  </a>
                </li>
                <li className="nav-item">
                  <a href="#franchise" className="nav-link">
                    Franchise
                  </a>
                </li>
                <li className="nav-item">
                  <a href="#directors" className="nav-link">
                    Our Directors
                  </a>
                </li>
                <li className="nav-item">
                  <a href="#faq" className="nav-link">
                    FAQ
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </section>
    </>
  );
}

export default Header;
